// extracted by mini-css-extract-plugin
module.exports = {"card":"StakeTx_card__3yG9C","details__container":"StakeTx_details__container__3TknU","alliance__info":"StakeTx_alliance__info__1Tw9_"};